<template>
  <div class="content access-auth">
    <div class="wrapper-section access-auth__wrapper">
      <section class="section access-auth__card access-auth__card--denied">
        <div class="section__content access-auth__denied">
          <div class="access-auth__status-code">{{ statusCode }}</div>
          <h1 class="access-auth__title">{{ title }}</h1>
          <p class="access-auth__subtitle">{{ description }}</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  reason: {
    type: String,
    default: 'forbidden',
    validator: value => ['expired', 'forbidden'].includes(value),
  },
})

const { t } = useI18n()

const statusCode = computed(() => (props.reason === 'expired' ? '403' : '403'))

const title = computed(() => (
  props.reason === 'expired'
    ? t('access.expired.title')
    : t('access.forbidden.title')
))

const description = computed(() => (
  props.reason === 'expired'
    ? t('access.expired.description')
    : t('access.forbidden.description')
))
</script>
